import th from "date-fns/locale/th";
import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OtpInput from "react-otp-input";
import "./inputDate.css";
import { monthsThai, years } from "../../pages/login/Login.FirstLogin";

registerLocale("th", th); // ลงทะเบียนภาษาไทย

export const InputWithLabel = ({
  type = "text",
  placeholder = "",
  className = "",
  value,
  onChange,
  label,
  disabled = false,
  headerStyle = " text-base text-mainblue font-semibold ",
  mainStyle = "",
}) => {
  // แปลงจาก Date -> string พ.ศ.
  const convertToBuddhistYear = (dateNow) => {
    const date = dateNow.split("/")[0];
    const month = dateNow.split("/")[1];
    const year = Number(dateNow.split("/")[2]) + 543;
    return `${String(date).padStart(2, "0")}/${String(month).padStart(
      2,
      "0"
    )}/${year}`;
  };

  const generateYearOptions = (date) => {
    const year = new Date(date).getFullYear();
    const years = [];
    // Generate a range of years (e.g., 10 years before and 10 years after current year)
    for (let i = year - 10; i <= year + 10; i++) {
      years.push(i);
    }
    return years;
  };

  // Component input ที่ใช้ใน DatePicker
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="relative w-full">
      <input
        locale="th"
        disabled={disabled}
        placeholder={placeholder}
        className={`${className} px-[14px] w-full border border-gray-200 rounded-full h-10 mt-[2px]`}
        onClick={onClick}
        value={convertToBuddhistYear(value)}
        readOnly
        ref={ref}
        onWheel={(e) => e?.target?.blur()}
      />
    </div>
  ));

  const CustomInputBirthdayHearder = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    return (
      <div className="flex items-center gap-5 justify-center">
        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          {"<"}
        </button>
        <select
          value={date ? new Date(date).getFullYear() : new Date().getFullYear()}
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {years?.map((option) => (
            <option key={option} value={option}>
              {option + 543}
            </option>
          ))}
        </select>

        <select
          value={
            monthsThai[date ? new Date(date).getMonth() : new Date().getMonth()]
          }
          onChange={({ target: { value } }) =>
            changeMonth(monthsThai.indexOf(value))
          }
        >
          {monthsThai?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          {">"}
        </button>
      </div>
    );
  };

  return (
    <div className={mainStyle}>
      <label className={headerStyle}>{label}</label>
      {type === "date" ? (
        <DatePicker
          selected={value ? new Date(value) : null}
          onChange={(date) => {
            if (!date) {
              onChange(null);
            } else {
              const gregorian = date.toISOString().split("T")[0]; // yyyy-MM-dd
              onChange(gregorian);
            }
          }}
          locale="th"
          dateFormat="dd/MM/yyyy"
          customInput={<CustomInput />}
          disabled={disabled}
          placeholderText={placeholder}
          renderCustomHeader={CustomInputBirthdayHearder}
        />
      ) : (
        <input
          disabled={disabled}
          type={type}
          placeholder={placeholder}
          className={`${className} px-[14px] w-full border border-gray-200 rounded-full h-10 mt-[2px]`}
          value={value}
          onChange={onChange}
          onWheel={(e) => e?.target?.blur()}
        />
      )}
    </div>
  );
};

export const InputMain = ({
  type = "text",
  placeholder = "",
  className = "",
  value,
  onChange,
  rounded = "rounded-full",
  margintop = "mt-[2px]",
  disabled = false,
  ...rest
}) => {
  return (
    <input
      {...rest}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      className={`${className} px-[14px] w-full border border-gray-200 ${rounded} h-10 ${margintop}`}
      value={value}
      onChange={onChange}
      onWheel={(e) => e?.target?.blur()}
    />
  );
};

export const InputPasswordMain = ({
  placeholder = "",
  className = "",
  value,
  onChange,
  passwordShown,
  ...rest
}) => {
  return (
    <input
      {...rest}
      type={passwordShown ? "text" : "password"}
      placeholder={placeholder}
      className={`${className} pl-[14px] pr-[36px] w-full h-full border border-gray-200 rounded-full `}
      value={value}
      onChange={onChange}
      onWheel={(e) => e?.target?.blur()}
    />
  );
};

export const InputNumberOTP = ({ otp, setOtp }) => {
  return (
    <OtpInput
      value={otp}
      onChange={setOtp}
      numInputs={6}
      containerStyle={"flex justify-center gap-2.5"}
      inputStyle={{
        width: "46px",
        height: "46px",
        backgroundColor: "#f9f9f9",
        border: "1px solid #EAEAEA",
        borderRadius: "0.375rem",
      }}
      inputType="number"
      // renderSeparator={<span>-</span>}
      renderInput={(props) => <input {...props} />}
    />
  );
};
